import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelFaqEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelFaqEntity
